import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { EnaioDataSource } from "./enaio-data-source.model";
import { DataSourceItem } from "./data-source-item.model";

export class DataSource {

    def: EnaioDataSource;
    data: DataSourceItem[];

    constructor(def: EnaioDataSource, data: DataSourceItem[]) {
        this.def = def;
        this.data = data;
    }

    getKey(item: DataSourceItem): string {
        return this.def.getKey(item);
    }

    findByKey(key: string): DataSourceItem {
        return this.data.find(item => item.key == key);
    }

}